import { render, staticRenderFns } from "./StartDynamicStageButton.vue?vue&type=template&id=9b320e64"
import script from "./StartDynamicStageButton.vue?vue&type=script&lang=js"
export * from "./StartDynamicStageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports